// @flow
export default class ScreeningParams {
  name: string;
  value: any;
  slug: string;
  description: string;

  constructor(data = {}) {
    this.name = data.name;
    this.value = data.value;
    this.slug = data.slug;
    this.description = data.description;
  }
}
